class Session {
  constructor() {
    this.authenticated = false;
    this.token = null;
    this.user = null;
  }

  authenticate(token, user) {
    this.token = token;
    this.user = user || this.user;
    this.authenticated = true;
  }

  logout() {
    this.authenticated = false;
    this.token = null;
    this.user = null;
  }

  setUser(user) {
    this.user = user;
  }
}

export default Session;
